import i18next from "i18next";
import React from "react";

const LangSeletor = () => {
	const [langOpen, setLangOpen] = React.useState(false);

	const changeLanguage = (lang: string) => {
		i18next.changeLanguage(lang);
	};
	return (
		<div
			className={`language-selector ${langOpen ? "open" : ""}`}
			onMouseOver={() => {
				setLangOpen(true);
			}}
			onMouseOut={() => {
				setLangOpen(false);
			}}
		>
			<div>
				<i className="fa-solid fa-language"></i>

				<ul className="language-options">
					<li className="language-option" onClick={() => changeLanguage("zh")}>
						中文
					</li>
					<li className="language-option" onClick={() => changeLanguage("en")}>
						English
					</li>
				</ul>
			</div>
		</div>
	);
};

export default LangSeletor;
